<template>
  <div class="wc-row mobileImageTop">
    <div
      class="form-div wc-col-no-padding wc-col-no-padding__sm-6 wc-col-no-padding__md-6"
    >
      <slot name="component"></slot>
    </div>
    <div
      class="image-div wc-col-no-padding wc-col-no-padding__sm-6 wc-col-no-padding__md-6"
    >
      <KeyVisualAccount></KeyVisualAccount>
    </div>
  </div>
</template>

<script setup lang="ts">
import KeyVisualAccount from '@/componentsTenant/rahmen/images/KeyVisualAccount.vue'
</script>

<style scoped>
.image-div {
  padding-top: 76px;
}

@media only screen and (max-width: 599.98px) {
  .mobileImageTop .form-div {
    order: 2;
  }

  .image-div {
    padding-top: var(--baseline);
  }
}
</style>
